module.exports = __webpack_public_path__ + "static/media/centre_medial_bonnevoie_entree.1f8fd755.jpg";